import { put, call } from 'redux-saga/effects';
import { SHOW_LOADER, HIDE_LOADER, SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS, SA_TRAVEL_FIELDS_MASTER_LIST_ERROR, SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR, SA_TRAVEL_FIELDS_MASTER_MODIFY_SUCCESS, SA_TRAVEL_FIELDS_MASTER_MODIFY_ERROR, SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS, SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR, AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS, AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR} from '../actions'; 
import { travelFieldsMasterList, travelFieldCreate, travelFieldModify, travelFieldDelete, affiliateTravelSettings } from '../services/travelModuleServices';

export function* travelFieldsMasterListSaga(payload) { 
    try {
    	yield put({ type: SHOW_LOADER})
      	const response = yield call(travelFieldsMasterList, payload);
      	yield put({ type: SA_TRAVEL_FIELDS_MASTER_LIST_SUCCESS, response })
    } catch(error) {
      yield put({ type: SA_TRAVEL_FIELDS_MASTER_LIST_ERROR, error });
    }finally{
      yield put({ type: HIDE_LOADER})
  }
}

export function* travelFieldCreateSaga(payload) { 
    try {
    	yield put({ type: SHOW_LOADER})
	    const response = yield call(travelFieldCreate, payload);
	    yield put({ type: SA_TRAVEL_FIELDS_MASTER_CREATE_SUCCESS, response })
    } catch(error) {
      yield put({ type: SA_TRAVEL_FIELDS_MASTER_CREATE_ERROR, error });
    }finally{
      yield put({ type: HIDE_LOADER})
  }
}

export function* travelFieldModifySaga(payload) { 
    try {
    	yield put({ type: SHOW_LOADER})
	    const response = yield call(travelFieldModify, payload);
	    yield put({ type: SA_TRAVEL_FIELDS_MASTER_MODIFY_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: SA_TRAVEL_FIELDS_MASTER_MODIFY_ERROR, error });
    }finally{
      yield put({ type: HIDE_LOADER})
  }
}

export function* travelFieldDeleteSaga(payload) { 
  try {
    yield put({ type: SHOW_LOADER})
    const response = yield call(travelFieldDelete, payload);
    yield put({ type: SA_TRAVEL_FIELDS_MASTER_DELETE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: SA_TRAVEL_FIELDS_MASTER_DELETE_ERROR, error });
  }finally{
    yield put({ type: HIDE_LOADER})
  }
} 

export function* affiliateTravelSettingsSaga(payload) { 
  try {
    yield put({ type: SHOW_LOADER})
    const response = yield call(affiliateTravelSettings, payload);
    yield put({ type: AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: AFFILIATE_TRAVEL_SETTINGS_LIST_ERROR, error });
  }finally{
    yield put({ type: HIDE_LOADER})
  }
} 


